import { render, staticRenderFns } from "./UiSubscription.vue?vue&type=template&id=cdc5b2cc&"
import script from "./UiSubscription.vue?vue&type=script&lang=js&"
export * from "./UiSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports